export enum PaymentRequestAmountTypeEnum {
    Percent = 'percent',
    Amount = 'amount',
}